import { KpiEnum } from './../../interfaces/kpi.enum';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Inject,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { catchError, filter, finalize } from 'rxjs/operators';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
} from '@angular/router';
import { FormService } from '../../shared/form.service';
import { ValidationService } from '../../services/validation.service';
import { SharedService } from '../../shared/shared.service';
import { ProposalService } from '../../shared/proposal.service';
import { PersonDetailsModalComponent } from '../../person-details-modal/person-details-modal.component';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { pushEvent } from '@allianz/tracking';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  NgForm,
  Validators,
} from '@angular/forms';
import { LocalStorageService } from 'ngx-localstorage';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { NxDateAdapter, NX_DATE_LOCALE } from '@aposin/ng-aquila/datefield';
import { Observable, combineLatest, of } from 'rxjs';
import { HelpModalComponent } from 'qbe-components';
import { NxMessageToastService } from '@aposin/ng-aquila/message';
import { TrackService } from 'src/app/services/track.service';
import { EvrotrustService } from 'src/app/shared/evrotrust.service';
import { HttpClient } from '@angular/common/http';


interface IFooterButton {
  type?: string;
  text: string;
  mode: 'primary' | 'secondary';
  disabled?: any;
  queryParams?: any;
  icon?: string;
  callback?: () => void;
  link?: string;
}

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent implements OnInit {
  @ViewChild('template1') templateRef!: TemplateRef<any>;
  @ViewChild('helpModal') helpModal: HelpModalComponent;

  @HostBinding('class.active')
  activeClass = false;
  private rButtonsList;
  @Input() leftButtonsList: IFooterButton[];
  @Input() data;
  @Input() leftButtonCallbacks;
  forseDisable;
  footerWithPrice;
  // rightButtonsList = [];
  is_disabled;
  buttonText1 = 'buttonText1';
  callBackButtonText = 'xxx';
  policyFirstInstallment;
  policyFirstInstallmentEuro;
  phoneCodes = [];
  phoneMask = '00 000 0000';
  phonePattern;
  phoneSeparator = [' '];
  deactivateMask = true;
  submitDisabled: boolean;
  fromCustPortal: boolean;
  fromAgentPage: boolean;

  footerData = {
    '/start': {
      rightButtonsList: [
        {
          text: 'footer.continue',
          mode: 'primary',
          disabled: true,
          link: 'object-details',
          trackingName: "NEXT_BUTTON"
        },
      ],
      isHelp: false,
    },
    '/object-details': {
      rightButtonsList: [
        {
          text: 'footer.continue',
          mode: 'primary',
          disabled: true,
          link: 'object-details',
          trackingName: "NEXT_BUTTON"
        },
      ],
      isHelp: true,
      dataBG: [
        {
          question: 'Какъв е видът на имуществото?',
          answer:
            'Моля, изберете вида на имуществото от падащото меню. При сключване на застраховка за Движимо имущество, стойността е предварително маркирана.',
        },
        {
          question: 'Какъв е адресът на имуществото?',
          answer:
            'Моля, посочете точен адрес на имуществото, което ще застраховате.',
        },
        {
          question: 'Какво е предназначението на имота?',
          answer: 'Моля, посочете какво е основното предназначение на имота.',
        },
        {
          question: 'Година на построяване?',
          answer:
            'Моля, посочете в коя година е построена сградата, в която се намира имотът или ако представлява самостоятелна сграда - в коя година е построена. При сключване на застраховка за Движимо имущество, моля посочете кога е построена сградата, в която се намира имуществото.',
        },
      ],
      dataEN: [
        {
          question: 'What is the type of the property?',
          answer:
            'Please select the property type from the drop-down menu. In case of Movable property only, the value is pre-marked.',
        },
        {
          question: 'Where is the property?',
          answer:
            'Please enter the exact address of the property you will insure.',
        },
        {
          question: 'What is property used for?',
          answer:
            'Please select from the drop-down menu the main usage of the property.',
        },
        {
          question: 'What is the construction year of the property?',
          answer:
            'Please choose the year when the property was built. In case of Movable property only, please indicate when the building in which the property is located was built.',
        },
      ],
    },
    '/object-details-2': {
      rightButtonsList: [
        {
          text: 'footer.continue',
          mode: 'primary',
          disabled: true,
          link: 'package-selection',
          trackingName: "NEXT_BUTTON"
        },
      ],
      isHelp: true,
      dataBG: [
        {
          question: 'Каква е площта на имота?',
          answer:
            'Моля, посочете каква е площта на имота, който ще застраховате по нотариален акт. Ако застраховате само движимо имущество, посочете площта на имота, в който се намира имуществото.',
        },
        {
          question: 'Каква е стойността на движимото/недвижимото имущество? ',
          answer:
            'Стойността на движимото/недвижимото имущество е изчислена автоматично. С натискане на бутон "Промени стойността" можете да направите корекция, като минималната стойност и диапазонът са посочени на екрана.',
        },
        {
          question: 'Имате ли регистрирани претенции за последните 5 год.?',
          answer:
            'Моля, изберете подходящия отговор, независимо към кой застраховател сте предявили конкретните претенции.',
        },
        {
          question: 'Какъв е Вашият телефонен номер?',
          answer:
            'Вашият мобилен телефон ще се използва, за да Ви предоставим допълнителна помощ в процеса на онлайн покупка. Той няма да бъде предоставен на трети лица или използван с цел реклама.',
        },
      ],
      dataEN: [
        {
          question: 'How big is the property?',
          answer:
            'Please indicate how big is ​​the property you will insure in accordance with the deed of ownership. In case of Movable property only, indicate the area of ​​the property in which the movable property is located.',
        },
        {
          question: 'What is the value of the movable/immovable property? ',
          answer:
            'The value of the movable/immovable property is calculated automatically. By pressing the Edit value button you can make an adjustment, as the minimum value and range are indicated on the screen.',
        },
        {
          question: 'Do you have any property claims for the last 5 years?',
          answer:
            'Please choose the appropriate option, regardless of which insurer you have made specific claims to.',
        },
        {
          question: 'What is your mobile number?',
          answer:
            'We will use your mobile number to provide you with additional assistance for the online purchase process. It will not be given to third parties or used for advertising purposes.',
        },
      ],
    },
    /*'/details-3': {
      rightButtonsList: [{
        text: 'footer.continue',
        mode: 'primary',
        disabled: '!parentForm.controls.personOwnerData.valid',
        link: 'offer',
        disableQueryParams: true
      }],
    },*/
    // '/newCarDetails-3': {
    //   footerWithPrice: false,
    //   rightButtonsList: [{
    //     text: 'footer.continue',
    //     mode: 'primary',
    //     disabled: true,
    //     link: 'package-selection',
    //     disableQueryParams: true
    //   }],
    //   isHelp:true
    // },
    '/package-selection': {
      footerWithPrice: true,
      rightButtonsList: [
        {
          disabled: false,
          text: 'footer.selectPackage',
          link: 'object-additional-details',
          trackingName: "PACKAGE_SELECTION_BUTTON"

        },
      ],
      isHelp: true,
      dataBG: [
        {
          question: 'Увеличете лимитите за Гражданска отговорност и стъкла',
          answer:
            'Стандартните лимити по застраховката са: за Гражданска отговорност - 2556.46 €, а за Стъкла - 255.65 €, които могат да бъдат увеличени, съответно за  Гражданска отговорност - 7669.38 €, а за Стъкла - 2556.46 €',
        },
        {
          question: 'Изберете самоучастие',
          answer:
            ' Самоучастието е сумата, с която участвате във всяко Застрахователно събитие. Размерът на договореното самоучастие се приспада от дължимата сума на Застрахователното обезщетение. При сключване на застраховка със самоучастие се прилага отстъпка от застрахователната премия.',
        },
      ],
      dataEN: [
        {
          question:
            'Increase the limits for Third Party Liability and Glass coverage',
          answer:
            'The standard limits for the insurance are: For Third Party Liability - 2556.46 €, and for Glass - 255.65 €, which can be increased, respectively for Third Party Liability - to 7669.38 €, and for Glass - to 2556.46 €.',
        },
        {
          question: 'Choose deductible',
          answer:
            'The deductible is the amount with which you participate in each Insurance Event. The amount of the agreed deductible is deducted from the amount due of the Insurance indemnity. When concluding insurance with deductible, a discount from the insurance premium is applied.',
        },
      ],
    },
    '/object-additional-details': {
      footerWithPrice: true,
      rightButtonsList: [
        {
          disabled: true,
          text: 'footer.continue',
          link: 'contact-details',
          trackingName: "NEXT_BUTTON"
        },
      ],
      isHelp: true,
      dataBG: [
        {
          question: 'Имуществото закупено ли е с банков кредит?',
          answer:
            ' Ако имуществото е ипотекирано в полза на банка кредитор, моля да изберете финансовата институция, на която ние ще изплатим застрахователното обезщетение.',
        },
        {
          question: 'Собственикът и Застраховащият едно и също лице ли са?',
          answer:
            'Ако Вие сте собственик на имуществото, моля отбележете ДА.Ако имуществото е собственост на друго Физическо или Юридическо лице, моля отбележете с НЕ и на следващите екрани ще са ни необходими и Вашите данни.',
        },
        {
          question:
            'Адресът на имуществото съвпада ли с адреса за кореспонденция на собственика?',
          answer:
            'Полицата ще бъдe  изпратенa на посочения адрес за кореспонденция на Застраховащия.',
        },
      ],
      dataEN: [
        {
          question: 'Is the property purchased with a bank loan?',
          answer:
            'If the property is mortgaged in favor of a bank, please choose the financial institution to which we should pay the insurance indemnity.',
        },
        {
          question: 'Are the Owner and the Policyholder the same person?',
          answer:
            'If you are the owner of the property, please mark YES.If the property is owned by another individual or legal entity, please mark NO. On the following screens you will fill in your personal data as a Policyholder.',
        },
        {
          question:
            "Does the property address match the owner's mailing address?",
          answer:
            'The insurance policy will be sent to the indicated address for correspondence of the Policyholder',
        },
      ],
    },
    // '/unregisteredCarFinalDetails': {
    //   footerWithPrice: true,
    //   rightButtonsList: [{
    //     disabled: true,
    //     text: 'footer.continue',
    //     link: 'contact-details',
    //   }],
    //   isHelp:true
    // },
    '/contact-details': {
      footerWithPrice: true,
      rightButtonsList: [
        {
          disabled: true,
          text: 'footer.continue',
          link: 'contact-details-2',
          trackingName: "NEXT_BUTTON"
        },
      ],
      isHelp: true,
      dataBG: [
        {
          question: 'Име, Презиме и Фамилия',
          answer: 'Моля, посочете имената на собственика на имуществото.',
        },
        {
          question: 'Пощенски код, улица и номер',
          answer:
            'Моля, въведете точен адрес за кореспонденция на собственика на имуществото.Моля да имате предвид, че на този адрес ще изпратим Полицата.',
        },
        {
          question: 'Мобилен телефон и имейл адрес',
          answer:
            'Мобилният телефон и имейлът се използват за допълнителна комуникация по повод застраховката.',
        },
      ],
      dataEN: [
        {
          question: 'Name, Surname, Family name',
          answer: 'Please enter the name/s of the Owner of the property.',
        },
        {
          question: 'Postal code, street and number',
          answer:
            'Please enter the correct mailing address of the property owner.Please note that if property owner and policyholder are same person, we will send the Insurance policy to this address.',
        },
        {
          question: 'Mobile phone and email address',
          answer:
            'The mobile phone and e-mail are used for additional communication regarding the insurance. They will not be given to third parties or used for advertising purposes.',
        },
      ],
    },
    '/contact-details-2': {
      footerWithPrice: true,
      rightButtonsList: [
        {
          disabled: true,
          text: 'footer.continue',
          link: 'summary',
          trackingName: "NEXT_BUTTON"
        },
      ],
      isHelp: true,
      dataBG: [
        {
          question: 'Име, Презиме и Фамилия',
          answer: 'Моля, посочете имената на застраховащия.',
        },
        {
          question: 'Пощенски код, улица и номер',
          answer:
            'Моля, въведете точен адрес за кореспонденция на застраховащия. Моля да имате предвид, че на този адрес ще изпратим Полицата.',
        },
        {
          question: 'Мобилен телефон и имейл адрес',
          answer:
            'Мобилният телефон и имейлът се използват за допълнителна комуникация по повод застраховката. ',
        },
      ],
      dataEN: [
        {
          question: 'Name, Surname, Family name',
          answer: 'Please enter the name/s of the Policyholder',
        },
        {
          question: 'Postal code, street and number',
          answer:
            'Please enter the correct mailing address of the Policyholder.Please note that we will send the Insurance policy to this address.',
        },
        {
          question: 'Mobile phone and email address',
          answer:
            'The mobile phone and e-mail are used for additional communication regarding the insurance. They will not be given to third parties or used for advertising purposes.',
        },
      ],
    },
    '/companyOwnerFinalDetails': {
      footerWithPrice: true,
      rightButtonsList: [
        {
          disabled: true,
          text: 'footer.continue',
          link: 'contact-details-2',
          trackingName: "NEXT_BUTTON"
        },
      ],
      isHelp: true,
      dataBG: [
        {
          question: 'Име, Презиме и Фамилия/Наименование',
          answer: 'Моля, посочете имената на собственика на имуществото.',
        },
        {
          question: 'Пощенски код, улица и номер',
          answer:
            'Моля, въведете точен адрес за кореспонденция на собственика на имуществото.Моля да имате предвид, че на този адрес ще изпратим Полицата.',
        },
        {
          question: 'Мобилен телефон и имейл адрес',
          answer:
            'Мобилният телефон и имейлът се използват за допълнителна комуникация по повод застраховката.',
        },
      ],
      dataEN: [
        {
          question: 'Name, Surname, Family name/Company name',
          answer: 'Please enter the name/s of the Owner of the property.',
        },
        {
          question: 'Postal code, street and number',
          answer:
            'Please enter the correct mailing address of the property owner.Please note that if property owner and policyholder are same person, we will send the Insurance policy to this address.',
        },
        {
          question: 'Mobile phone and email address',
          answer:
            'The mobile phone and e-mail are used for additional communication regarding the insurance. They will not be given to third parties or used for advertising purposes.',
        },
      ],
    },
    '/insurerData': {
      footerWithPrice: true,
      rightButtonsList: [
        {
          disabled: true,
          text: 'footer.continue',
          link: 'summary',
          trackingName: "NEXT_BUTTON"
        },
      ],
      isHelp: true,
      dataBG: [
        {
          question: 'Име, Презиме и Фамилия',
          answer: 'Моля, посочете имената на застраховащия.',
        },
        {
          question: 'Пощенски код, улица и номер',
          answer:
            'Моля, въведете точен адрес за кореспонденция на застраховащия. Моля да имате предвид, че на този адрес ще изпратим Полицата.',
        },
        {
          question: 'Мобилен телефон и имейл адрес',
          answer:
            'Мобилният телефон и имейлът се използват за допълнителна комуникация по повод застраховката.',
        },
      ],
      dataEN: [
        {
          question: 'Name, Surname, Family name',
          answer: 'Please enter the name/s of the Policyholder',
        },
        {
          question: 'Postal code, street and number',
          answer:
            'Please enter the correct mailing address of the Policyholder.Please note that we will send the Insurance policy to this address.',
        },
        {
          question: 'Mobile phone and email address',
          answer:
            'The mobile phone and e-mail are used for additional communication regarding the insurance. They will not be given to third parties or used for advertising purposes.',
        },
      ],
    },
    '/summary': {
      footerWithPrice: true,
      rightButtonsList: [
        {
          text: 'footer.continue',
          mode: 'primary',
          disabled: true,
          link: 'consents',
          trackingName: "NEXT_BUTTON"
        },
      ],
      isHelp: false,
    },
    '/consents': {
      footerWithPrice: true,
      rightButtonsList: [
        {
          disabled: true,
          text: 'footer.issuePolicy',
          link: 'payment',
          trackingName: "POLICY_BUTTON"
        },
      ],
      isHelp: true,
      dataBG: [
        {
          question: 'Съгласия и Декларации',
          answer:
            'Предоставянето на Съгласията и Декларациите от Ваша страна са важни за нас, за да можем да обработваме Вашите данни с оглед изпълняване на ангажиментите ни по застраховката. Моля да се запознаете с конкретните текстове в публикуваните на страницата линкове.',
        },
        {
          question:
            'Декларирация за адресат на електронни изявления по повод на застраховката',
          answer:
            'С Вашето съгласие да бъдете адресат на електронни заявления по повод на застраховката ще създадете предпоставки за официална електронна кореспонденция помежду ни.',
        },
      ],
      dataEN: [
        {
          question: 'Consents and Declarations',
          answer:
            'Your Consents and Declarations are important to us so that we can process your data in order to fulfill our insurance commitments. Please read the specific texts in the links published on the page',
        },
        {
          question:
            'Declaration for the addressee of electronic statements regarding the insurance',
          answer:
            'With your consent to be the addressee of electronic applications regarding the insurance, you will create preconditions for official electronic correspondence between us.',
        },
      ],
    },
    '/information': {
      footerWithPrice: true,
      rightButtonsList: [
        {
          disabled: false,
          text: 'footer.continue',
          link: 'payment',
          trackingName: "PAYMENT_BUTTON"
        },
      ],
      isHelp: false,
    },
    '/payment': {
      footerWithPrice: true,
      rightButtonsList: [
        {
          text: 'footer.continuePay',
          mode: 'primary',
          trackingName: "NEXT_BUTTON"
        },
      ],
      isHelp: false,
    },
    '/mobileInfo': {
      rightButtonsList: [
        {
          text: 'footer.continue',
          mode: 'primary',
          link: 'createOffer',
          trackingName: "NEXT_BUTTON"
        },
      ],
      isHelp: false,
    },
  };

  get rightButtonsList() {
    this.rButtonsList?.map((item) => {
      if (Array.isArray(item.link)) {
        return this.parentForm.controls?.vehicleDTO?.controls?.mvrVehicleType
          ?.value === '1'
          ? item.link[0]
          : item.link[1];
      }
      if (
        item.link === 'contact-details' &&
        this.formService.currentForm.controls.isCompany.value
      ) {
        item.link = 'companyOwnerFinalDetails';
      } else if (
        item.link === 'companyOwnerFinalDetails' &&
        !this.formService.currentForm.controls.isCompany.value
      ) {
        item.link = 'contact-details';
      }
    });
    return this.rButtonsList;
  }

  getState(item) {
    return item && this.validationService.state;
    // return typeof item === 'string' ? this.resolve(item, this) : item;
  }

  set rightButtonsList(val) {
    this.forseDisable = true;
    setTimeout(() => {
      this.forseDisable = false;
    }, 300);
    val = val || [];
    this.rButtonsList = val;
  }

  @Input() outlet;
  componentDialogRef: NxModalRef<PersonDetailsModalComponent>;
  componentAgentRef: NxModalRef<PersonDetailsModalComponent>;
  parentForm;
  buttonText;
  isHelp: boolean;
  titles: [];

  constructor(
    private router: Router,
    private formService: FormService,
    public validationService: ValidationService,
    public sharedService: SharedService,
    public proposalService: ProposalService,
    public dialogService: NxDialogService,
    private chr: ChangeDetectorRef,
    public translate: TranslateService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private http: HttpClient,
    public localStorage: LocalStorageService,
    public dialogService1: NxDialogService,
    public formBuilder: FormBuilder,
    private messageToastService: NxMessageToastService,
    public el: ElementRef,
    private evrotrustService: EvrotrustService,
    public trackService: TrackService,
    @Inject(NX_DATE_LOCALE) public nxDateLocale: string,
    public nxDateAdapter: NxDateAdapter<moment.Moment>
  ) {
    this.token1 = undefined;
    if (this.parentForm !== this.formService.currentForm) {
      this.parentForm = this.formService.currentForm;
    }




    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (this.parentForm !== this.formService.currentForm) {
          this.parentForm = this.formService.currentForm;
        }
        // this.emailForm.get('mobile').patchValue(this.parentForm.controls.firstCountryCode.value+this.parentForm.controls.firstPhoneNumber.value);
        // this.emailForm.get('name').patchValue(this.parentForm.controls.firstFirstName.value);
        setTimeout(() => {
          this.forseDisable = false;
          this.activeClass = false;
          this.chr.detectChanges();
        }, 300);
        this.validationService.showErrorBannerSource$.next(false);
        const url = event.urlAfterRedirects.split('?')[0];
        this.rButtonsList = this.footerData[url]?.rightButtonsList || [];
        this.footerWithPrice = this.footerData[url]?.footerWithPrice;
        this.isHelp = this.footerData[url]?.isHelp;
        if (this.isHelp) {
          // this.helpModal.toggleHelpModalContent();
        }
        if (this.localStorage.get('language') === 'bg') {
          this.titles = this.footerData[url]?.dataBG;
          this.buttonText = 'Помощ';
        } else {
          this.titles = this.footerData[url]?.dataEN;
          this.buttonText = 'Need Help';
        }
      });

    this.translate.onLangChange.subscribe(() => {
      const url = this.router.url.split('?')[0];
      if (this.localStorage.get('language') === 'bg') {
        this.titles = this.footerData[url]?.dataBG;
        this.buttonText = 'Помощ';
      } else {
        this.titles = this.footerData[url]?.dataEN;
        this.buttonText = 'Need Help';
      }
    });
  }

  get countryCode() {
    return this.emailForm.controls['countryCode'];
  }
  get mobile() {
    return this.emailForm.controls['mobile'];
  }


  recapchaFilter;
  invokeReCaptcha() {
    const urlEndpoint = `/api/v1/recaptcha/`;

    // let response: TokenType = {
    //   token: null
    // }
    // this.recaptchaV3Service.execute('importantAction').subscribe(
    //   token => {

    //     response.token = token;
    //     this.http.post<GoogleResponse>(urlEndpoint, response).subscribe((result: GoogleResponse) => {

    //       this.recapchaFilter = Number(result.score);

    //     })

    //     if (this.recapchaFilter <= 0.50) {
    //       this.openFromTemplate1();

    //     }
    //   }
    // );
  }

  isPaymentScreen(){
    return !(window.location.pathname.includes('/payment'))
  }

  onTrack(navigation, value) {
    this.trackService.pushEventTracking(navigation, value);
  }

  resolve(path, obj, separator = '.') {
    const properties = Array.isArray(path)
      ? path
      : path.replace('!', '').split(separator);
    const result = properties.reduce((prev, curr) => prev && prev[curr], obj);
    return path[0] === '!' ? !result : result;
  }

  ngOnInit(): void {
    this.fromCustPortal = !!this.sharedService._isCustomerPortal;
    this.fromAgentPage = !!this.sharedService._isAgentWebPage;
    this.emailForm = this.formBuilder.group({
      name: new FormControl('', [Validators.required]),
      email: new FormControl('', {
        validators: Validators.email,
        updateOn: 'blur',
      }),
      countryCode: new FormControl('', [Validators.required]),
      mobile: new FormControl('', {
        validators: Validators.required,
        updateOn: 'blur',
      }),
      callMeBackNow: !this.chosenSchedule,
      scheduleCall: this.chosenSchedule,
      sentFrom: this.router.url.split('?')[0],
    });
    setTimeout(() => {
      this.forseDisable = false;
    }, 300);
    const url = this.router.url.split('?')[0];
    this.rButtonsList = this.footerData[url]?.rightButtonsList || [];
    this.footerWithPrice = this.footerData[url]?.footerWithPrice;
    this.isHelp = this.footerData[url]?.isHelp;
    this.titles = this.footerData[url]?.data;
    if (this.localStorage.get('language') === 'bg') {
      this.titles = this.footerData[url]?.dataBG;
      this.buttonText = 'Помощ';
    } else {
      this.titles = this.footerData[url]?.dataEN;
      this.buttonText = 'Need Help';
    }
    this.sharedService.getPhoneCodes().subscribe((res) => {
      this.phoneCodes = res.map(function (el: any) {
        return el.value;
      });
    });

    this.emailForm.get('countryCode').valueChanges.subscribe((mobileCode) => {
      if (mobileCode !== '+359') {
        this.deactivateMask = true;
        this.phonePattern = '[0-9]{0,15}';
        this.emailForm.get('mobile').updateValueAndValidity();
      } else {
        this.deactivateMask = false;
        this.phonePattern = '^((?!(0))[0-9]{9})$';
        if(this.emailForm.get('mobile').value.length>9){
          this.emailForm.get('mobile').value = this.emailForm.get('mobile').value.slice(0, 9);
        }
        this.emailForm.get('mobile').updateValueAndValidity();
      }
    });

    this.formService.currentForm.get('street').valueChanges.subscribe((res) => {
      if(this.formService.currentForm.get('block').value==''){
        this.formService.showGoogleAddress = false
        this.formService.currentForm.get('fullAddress').setValue('');
      }
    })
    this.formService.currentForm.get('block').valueChanges.subscribe((res) => {
      if(this.formService.currentForm.get('street')==''){
        this.formService.showGoogleAddress = false
        this.formService.currentForm.get('fullAddress').setValue('');
      }
    })


    this.formService.currentForm.get('apartment').valueChanges.subscribe((res) => {
      this.formService.showGoogleAddress = false
      this.formService.currentForm.get('fullAddress').setValue('');
    })
    this.formService.currentForm.get('cityName').valueChanges.subscribe((res) => {
      this.formService.showGoogleAddress = false
      this.formService.currentForm.get('fullAddress').setValue('');
    })
    this.formService.currentForm.get('postCode').valueChanges.subscribe((res) => {
      this.formService.showGoogleAddress = false
      this.formService.currentForm.get('fullAddress').setValue('');
    })
    this.formService.currentForm.get('streetNumber').valueChanges.subscribe((res) => {
      this.formService.showGoogleAddress = false
      this.formService.currentForm.get('fullAddress').setValue('');
    })


    this.formService.currentForm.get('floor').valueChanges.subscribe((res) => {
      this.formService.showGoogleAddress = false
      this.formService.currentForm.get('fullAddress').setValue('');
    })
    this.formService.currentForm.get('entrance').valueChanges.subscribe((res) => {
      this.formService.showGoogleAddress = false
      this.formService.currentForm.get('fullAddress').setValue('');
    })

    this.formService.currentForm.get('propertySubcategory').valueChanges.subscribe((res) => {
      if(res == '11' || res == '1') {
        this.formService.currentForm.get('apartment').clearValidators();
        this.formService.currentForm.get('entrance').clearValidators();
        this.formService.currentForm.get('floor').clearValidators();
        this.formService.currentForm.get('apartment').updateValueAndValidity();
        this.formService.currentForm.get('entrance').updateValueAndValidity();
        this.formService.currentForm.get('floor').updateValueAndValidity();
        this.formService.currentForm.get('block').clearValidators();
        this.formService.currentForm.get('block').updateValueAndValidity();

      }else {
        this.formService.currentForm.get('apartment').addValidators(Validators.required);
        this.formService.currentForm.get('entrance').addValidators(Validators.required);
        this.formService.currentForm.get('floor').addValidators(Validators.required);
        this.formService.currentForm.get('block').addValidators(Validators.required);
        this.formService.currentForm.get('block').updateValueAndValidity();
        this.formService.currentForm.get('apartment').updateValueAndValidity();
        this.formService.currentForm.get('entrance').updateValueAndValidity();
        this.formService.currentForm.get('floor').updateValueAndValidity();

      }
    })


     }

  ngAfterViewInit() {
    let interv = setInterval(() => {
      let tempCap = document.getElementsByClassName(
        'grecaptcha-badge'
      ) as HTMLCollectionOf<HTMLElement>;
      if(tempCap[0]!==undefined){
        if (tempCap[0].style.zIndex === '11') {
          clearInterval(interv);
        } else {
          tempCap[0].style.zIndex = '11';
          // console.log("test")
        }
      }
    }, 1000);
  }

  setCallMeBack() {
    this.submitDisabled = false;
    this.deactivateMask=true;
    if (!this.parentForm.controls.policyholderData.controls.firstName.value) {
      if (this.parentForm.controls.firstFirstName.value) {
        this.emailForm
          .get('name')
          .setValue(this.parentForm.controls.firstFirstName.value);
      }
    } else {
      this.emailForm
        .get('name')
        .setValue(
          this.parentForm.controls.policyholderData.controls.firstName.value
        );
    }

    if (!this.parentForm.controls.policyholderData.controls.phoneNumber.value) {
      if (this.parentForm.controls.firstPhoneNumber.value) {
        this.emailForm
        .get('countryCode')
        .setValue(this.parentForm.controls.firstCountryCode.value);
        this.emailForm
          .get('mobile')
          .setValue(this.parentForm.controls.firstPhoneNumber.value);
          this.emailForm
          .get('name')
          .setValue(this.parentForm.controls.firstFirstName.value);

      }
    } else {
      if( this.parentForm.controls.policyholderData.controls.countryCode.value!==null &&  this.parentForm.controls.policyholderData.controls.countryCode.value!== '') {
        this.emailForm
        .get('countryCode')
        .setValue(
          this.parentForm.controls.policyholderData.controls.countryCode.value
        );
       }
      this.emailForm
        .get('mobile')
        .setValue(
          this.parentForm.controls.policyholderData.controls.phoneNumber.value
        );


    }
    if (this.parentForm.controls.policyholderData.controls.email.value) {
      this.emailForm
        .get('email')
        .setValue(
          this.parentForm.controls.policyholderData.controls.email.value
        );
    }
    if(!this.emailForm.get('countryCode').value){
      this.emailForm.get('countryCode').patchValue('+' + this.phoneCodes[0]);
    }
  }
  disableObjectDetailsRoute() {

    // if(this.router.url == '/object-details' ) {
    //   if(!this.formService.currentForm.get('street').valid || !this.formService.currentForm.get('block').valid || !this.formService.currentForm.get('apartment').valid || !this.formService.currentForm.get('fullAddress').valid || this.formService.currentForm.get('fullAddress').value == null || !this.formService.currentForm.get('purpose').valid || !this.formService.currentForm.get('yearOfConstruction').valid )
    //   {
    //   return true
    //   }
    // }else {
    //   return false
    // }
  }
  gmapsFindAddress() {

    const payload = {
      "postCode": this.formService.currentForm.get('postCode').value,
      "settlement": this.formService.currentForm.get('cityName').value,
      "street": this.formService.currentForm.get('street').value,
      "streetNumber" :this.formService.currentForm.get('streetNumber').value,
      "block": this.formService.currentForm.get('block').value,
    }
    // debugger
    if(this.router.url == '/object-details') {
      if( this.formService.currentForm.get('street').valid &&  this.formService.currentForm.get('streetNumber').valid &&  this.formService.currentForm.get('block').valid && this.formService.currentForm.get('apartment').valid &&  this.formService.currentForm.get('entrance').valid &&
      this.formService.currentForm.get('floor').valid   && this.formService.currentForm.get('purpose').valid &&this.formService.currentForm.get('propertySubcategory').valid &&  this.formService.currentForm.get('yearOfConstruction').valid &&  this.formService.currentForm.get('postCode').valid&&  this.formService.currentForm.get('cityName').valid )
        {
      if(!this.formService.showGoogleAddress){
        this.sharedService.loadingSpinner = true;
        this.footerData['/object-details'].rightButtonsList[0].link = 'object-details'
        this.sharedService.gmapsFindAddresses(payload).pipe(
          finalize(() => this.sharedService.loadingSpinner = false )
          ).subscribe((res: any) =>
          {
            this.sharedService.gmapsSelectAddress$.next(res) ;
              this.formService.currentForm.get('fullAddress').setValue(null)
              if(res.length == 0) {
                this.sharedService.errorMessageFindAddress$.next(true);
                this.formService.currentForm.get('fullAddress').setValue('')
                this.formService.currentForm.get('street').setValue('')
                this.formService.currentForm.get('streetNumber').setValue('')
                this.formService.currentForm.get('block').setValue('')
                this.formService.currentForm.get('apartment').setValue('')
                this.formService.currentForm.get('entrance').setValue('')
                this.formService.currentForm.get('floor').setValue('')

                this.formService.showGoogleAddress = false
              }

              if (res[0].postCode !== this.formService.currentForm.get('postCode').value) {
                this.sharedService.errorMessageDifferentPostCodeReturned$.next(true);
              }
              if(res.length == 1) {
                this.formService.currentForm.get('fullAddress').setValue(res[0])
                const {postCode, longitude, latitude , placeId, streetName} = this.formService.currentForm.get('fullAddress').value

                this.formService.currentForm.get('longitude').setValue(longitude)
                this.formService.currentForm.get('latitude').setValue(latitude)
                this.formService.currentForm.get('placeId').setValue(placeId)
                this.formService.currentForm.get('postCode').setValue(postCode)


                this.router.navigateByUrl('/object-details-2')
              }else if(res.length > 1) {
                this.footerData['/object-details'].rightButtonsList[0].link = '/object-details-2'
              }
              if(res.length > 1) {

                this.formService.showGoogleAddress = true
              }else {
                this.formService.showGoogleAddress = false
              }
              this.proposalService.setOwnerData(res[0].postCode, res[0].settlement);
           } )
      }else {

        if(this.formService.currentForm.get('fullAddress').value !== ''){
          const {postCode} = this.formService.currentForm.get('fullAddress').value
          this.formService.currentForm.get('postCode').setValue(postCode)

          this.router.navigateByUrl('/object-details-2')
        }


      }
    }

    }


  }
  openAgentDialog() {
    this.componentAgentRef = this.dialogService.open(
      PersonDetailsModalComponent,
      {
        panelClass: 'callAgentDialog',
        data: {
          firstName: 'callAgent.firstName',
          lastName: 'callAgent.lastName',
          phoneNumber: 'callAgent.phone',
          heading: 'callAgent.heading',
          subHeading: 'callAgent.subHeading',
          btnOkText: 'callAgent.btnOkText',
          agent: true,
        },
        showCloseIcon: true,
      }
    );
  }

  activeFunction(disabled, router?) {
    // if (this.validationService.getInvalidControls()) {
    //   const el = (this.validationService.getInvalidControls()?.nativeElement as HTMLElement);
    //   el?.focus();
    //   el?.parentElement?.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
    //   el?.parentElement?.focus();
    //     this.messageToastService.open("help", { duration: 3000 });

    // }
    const controls = this.validationService.controlList;

    if (controls) {
      const invalids = controls
        .map((c) => {
          if (c.status === 'INVALID' || c.hasError('required')) {
            return c;
          }
        })
        .filter((c) => {
          return c !== undefined;
        });
  


      if (invalids.length > 0) {
        const control = invalids[0] || null;
        const el = control?.nativeElement as HTMLElement;
        if (control instanceof FormControl) {
          if (el.tagName === 'INPUT') {
            if (
              el.getAttribute('type') != null &&
              (el.getAttribute('type') === 'radio' ||
                el.getAttribute('type') === 'checkbox')
            ) {
              this.validationService.showErrorBannerSource$.next(true);
            }
          } else if (
            el.tagName.toLowerCase() === 'nx-radio' ||
            el.tagName.toLowerCase() === 'nx-checkbox'
          ) {
            this.validationService.showErrorBannerSource$.next(true);
          }

          el?.focus();
          el?.parentElement?.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
          el?.parentElement?.focus();
          // control?.markAsTouched({ onlySelf: true });
          // control?.markAsDirty({ onlySelf: true });
          control?.markAsUntouched({ onlySelf: true });
          control?.markAsPristine({ onlySelf: true})
        } else if ( this.validationService.getInvalidControls() instanceof FormGroup ) {
          this.activeFunction(null);
        }
      }
      else if(this.validationService.errorPhone$.getValue()==true){
        const element = document.getElementsByClassName('phone-field-input').item(0)
        if (element) {
          (element as HTMLElement).focus();
        }


      }
      else{
        if(router){
          this.router.navigateByUrl(router);
          this.validationService.errorPhone$.next(false)
        }
        if (!disabled) {
          this.activeClass = !this.activeClass;
        }
      }
    }
  }

  openSaveDialog(productProposals, selectedItem) {
    this.componentDialogRef = this.dialogService.open(
      PersonDetailsModalComponent,
      {
        panelClass: 'personDetailsDialog',
        //saveQuote.ownName is used only as flag for ngIf. The data is in firstName.
        data: {
          firstName: 'saveQuote.ownName',
          email: 'saveQuote.email',
          phoneNumber: 'saveQuote.phone',
          heading: 'saveQuote.heading',
          subHeading: 'saveQuote.subHeading',
          btnOkText: 'footer.saveQuote',
          offer: true,
          productProposals,
          selectedItem,
        },
        showCloseIcon: true,
      }
    );
  }

  getSelectedSum(proposals, item, val) {
    const instalments = {
      1: 'One',
      2: 'Two',
      4: 'Four',
    };
    const sum = proposals[`bottom${item}${instalments[val]}`];
    this.formService.currentForm.controls.chosenPremiumSaveOffer.patchValue(
      sum
    );
    return sum;
  }

  getSelectedSumEuro(proposals, item, val) {
    const instalments = {
      1: 'One',
      2: 'Two',
      4: 'Four',
    };
    // console.log(proposals, item, val);
    const sumCurr2 = proposals[`bottom${item}${instalments[val]}Curr2`];
    // if(val === 1) {
      this.formService.currentForm.controls.chosenPremiumSaveOfferCurr2.patchValue(sumCurr2)
    // }
    return sumCurr2;
  }

  openDialog(productProposals, selectedItem) {
    return this.openSaveDialog(productProposals, selectedItem);
  }

  openFromTemplate1(): void {
    this.dialogService1.open(this.templateRef, {
      ariaLabel: 'A simple modal',
      disableClose: true,
      width: '380px',
    });
  }

  token1: string | undefined;
  public send1(form: NgForm): void {
    if (form.invalid) {
      for (const control of Object.keys(form.controls)) {
        form.controls[control].markAsTouched();
      }
      return;
    }
    // console.dir("test")
    console.debug(`Token [${this.token1}] generated`);

    this.dialogService1.closeAll();
    this.token1 = undefined;
  }

  //Call me back modal component

  @ViewChild('CallMeBack') callMeBack: TemplateRef<any>;
  @ViewChild('ТhankYou') thankYou: TemplateRef<any>;

  callMe: NxModalRef<any>;
  ThankYouTemplate: NxModalRef<any>;

  minDate = moment().add(1, 'days').format('DD.MM.YYYY');
  maxDate = moment().add(8, 'days').format('DD.MM.YYYY');

  hours = [
    '9:00',
    '9:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
  ];

  chosenSchedule = false;
  emailForm;
  cannotVerify;



  chooseSchedule() {
    this.chosenSchedule = !this.chosenSchedule;
    if (this.chosenSchedule === false) {
      this.emailForm.removeControl('date');
      this.emailForm.removeControl('hour');
      this.trackService.addAttribute('callMeBack.date', 'Now' );
      this.trackService.addAttribute('callMeBack.hour', 'Now' )
    } else {
      this.emailForm.addControl(
        'date',
        new FormControl('', Validators.required)
      );
      this.emailForm.addControl(
        'hour',
        new FormControl('', Validators.required)
      );
    }
  }
  onlyWeekdays = (date: moment.Moment) => {
    return (
      moment(date).toDate() > moment().toDate() &&
      moment(date).toDate() < moment().add(7, 'days').toDate() &&
      moment(date).day() !== 0 &&
      moment(date).day() !== 6
    );
  };

  validateAllEmailFormFields(formGroup: FormGroup) {
    //{1}

    Object.keys(formGroup.controls).forEach((field) => {
      //{2}

      const control = formGroup.get(field); //{3}

      if (control instanceof FormControl) {
        //{4}

        control.markAsTouched({ onlySelf: true });

        control.markAsDirty({ onlySelf: true });

        control.setErrors(control.errors);
      } else if (control instanceof FormGroup) {
        //{5}

        this.validateAllEmailFormFields(control); //{6}
      }
    });
  }

  submitButton() {
    if (this.emailForm.status === 'VALID') {
      if (this.chosenSchedule === true) {
        this.emailForm.value.date = moment(this.emailForm.value.date).format(
          'DD.MM.YYYY'
        );
      } else {
        let scheduledCall = {
          datе: 'СЕГА',
          hour: 'СЕГА',
        };
        Object.assign(this.emailForm.value, scheduledCall);
      }
      this.emailForm.value.callMeBackNow = !this.chosenSchedule;
      this.emailForm.value.scheduleCall = this.chosenSchedule;
      this.emailForm.value.mobile =
        this.emailForm.value.countryCode + this.emailForm.value.mobile;
      this.emailForm.value.sentFrom = this.router.url;
      this.submitDisabled = true;
      //this.emailForm.removeControl('countryCode')
      this.sharedService.sendKpiTrackingData(KpiEnum.LEAD_SIDE_BAR).subscribe();
      this.trackService.pushEventTracking('navigationButton', 'Sending');

      this.http
        .post('/api/v1/email/need-help-call-me-back', this.emailForm.value)
        .subscribe((_) => {
          //this.dialogService.closeAll()
          this.trackService.pushEventTracking('text', 'Thank you – call me')
          this.trackService.pushEventTracking('faq', '');
          this.helpModal.toggleCallBackModalContent();
          this.ThankYouTemplate = this.dialogService.open(this.thankYou, {
            showCloseIcon: true,
          });
          this.emailForm.reset();
          this.submitDisabled = false;
        });
    } else {
      this.validateAllEmailFormFields(this.emailForm);
    }
  }

  checkInvalidControls() {
    const controls = this.validationService.controlList;

    if (controls) {
      const invalids = controls
        .map((c) => {
          if (c.status === 'INVALID' || c.hasError('required')) {
            return c;
          }
        })
        .filter((c) => {
          return c !== undefined;
        });

      if (invalids.length === 0) {
        this.validationService.showErrorBannerSource$.next(false);
      }
    }
  }

  timer;
  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    clearTimeout(this.timer);
    this.setTimer();
  }

  @HostListener('document:click', ['$event'])
  onClickEvent(event: MouseEvent) {
    clearTimeout(this.timer);
    this.setTimer();
    this.checkInvalidControls();
  }

  //   @HostListener('window:unload', ['$event'])
  // unloadHandler(event) {
  //   this.openDialog1();
  // }

  // @HostListener('window:beforeunload', ['$event'])
  // beforeUnloadHander(event) {
  //   this.openDialog1();
  //   event.preventDefault();
  //     return false;
  // }

  @HostListener('window:beforeunload', ['$event'])
  onWindowClose(event: any): void {
    // if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
    if (this.router.url === '/payment') {
      return;
    }
    this.openDialog1();
    event.preventDefault();
    event.returnValue = false;
    // }

    switch (this.router.url) {
      case '/object-details-2': {
        this.sharedService
          .sendKpiTrackingData(KpiEnum.LEAD_PRE_QUOTE)
          .pipe(
            catchError(() => {
              return of(true);
            })
          )
          .subscribe();
        break;
      }
      case '/package-selection': {
        this.sharedService
          .sendKpiTrackingData(KpiEnum.LEAD_QUOTE_PAGE)
          .pipe(
            catchError(() => {
              return of(true);
            })
          )
          .subscribe();
        break;
      }
      default: {
        //statements;
        break;
      }
    }
  }
  openDialog1() {
    if(this.evrotrustService.isLoading!==true){
      this.setCallMeBack();
      this.helpModal.toggleCallBackModalContent();
      this.trackService.pushEventTracking('faq', '');
      this.trackService.pushEventTracking('text', 'Call me')
    }

  }

  setTimer() {
    this.timer = setTimeout(() => {
      this.openDialog1();
    }, 1000 * 119);
  }
}
